import { nanoid } from 'nanoid';
import { $notiApi } from './notiStores';
import { NotiType } from './notiTypes';

export const sendError = (text: string) => {
  $notiApi.add({ id: nanoid(), type: NotiType.error, message: text });
};

export const sendWarning = (text: string) => {
  $notiApi.add({ id: nanoid(), type: NotiType.warning, message: text });
};

export const sendSuccess = (text: string) => {
  $notiApi.add({ id: nanoid(), type: NotiType.success, message: text });
};
